import React from 'react';
import { Form, Row, Input, Col, Button, Select, Typography, DatePicker, Descriptions, Modal } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import FormControl from 'components/Forms/FormControl';
import { withRouter, RouteComponentProps, NavLink, useLocation } from 'react-router-dom';
import IFilterSelectOption from 'components/Forms/DataGrid/FilterSelectbox/IFilterSelectOption';
import JcsdAccountHandler from '../JcsdAccountHandler';
import ValidationUtility from '../../../Core/ValidationUtility';
import SimpleSelect from '../../Forms/SimpleSelect';
import {
    UserStatus,
    SlimUser,
    Operations,
    Account,
    SlimAccount,
    ApplicationViewModel,
    ApplicationStatus,
} from '../../../Core/Api/Api';
import Utility from 'Core/Utility';
import ISelectOption from 'components/Forms/SimpleSelect/ISelectOption';
import {
    singleColFormColSize,
    FullWithButton,
    doubleColFormColSize,
} from '../../Forms/Form.Styled';
import MaskedInput from 'components/Forms/MaskedInput';
import { RightAlignedRow } from 'components/Styled/Layout/RightAlignedRow';
import DetailsMode from 'Core/models/DetailsMode';
import DetailsData from 'Core/models/DetailsData';
import NotificationService from 'Core/NotificationService';
import { LeftAlignedRow } from 'components/Styled/Layout/LeftAlignedRow';
import AuthContext from 'Context/AuthContext';
import moment from 'moment';
import { BorderlessDescriptions } from '../../Offering/OfferingDetailsView';
import { CenterAlignedRow } from '../../Styled/Layout/CenterAlignedRow';
import { ClientApplicationHandler } from 'components/Client/ClientApplicationHandler';
import NumberFormat from 'react-number-format';
import { BrandedButton } from '../../Styled/Branded/BrandedButton';
import { startCase } from 'lodash';
import { PaymentMethod } from '../../../Core/Api/Api';

const { Title } = Typography;
const { confirm } = Modal;

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode;
}

export interface State {
    jurisdictions: ISelectOption[];
    roles: ISelectOption[];
    status: ISelectOption[];
    user?: SlimUser;
    detailsMode: DetailsMode;
    application?: ApplicationViewModel;
}

export class IpoApplicationDetailsFormWithoutFormAndRouter extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    handler: ClientApplicationHandler;

    constructor(props: Props) {
        super(props);

        this.state = {
            jurisdictions: [],
            roles: [],
            status: [],
            detailsMode: DetailsMode.New,
        };
        this.handler = new ClientApplicationHandler(props);
    }

    componentDidMount() {
        this.getAccountDetails();
    }

    generalApplyClicked(offeringId, sharePoolId) {
        this.props.history.push(
            `/ipo/apply/${offeringId}`,
            new DetailsData(DetailsMode.Edit, offeringId, this.state.application?.applicationId)
        );

    };

    cancelApplication(applicationId) {
        const urlState = this.props.location.state as DetailsData | undefined;
        confirm({
            title: 'Cancel Application',
            content: <>Are you sure you want to cancel this application?</>,
            cancelText: "No",
            okText: "Yes",
            onOk: () => {
                this.handler.CancelApplication(urlState?.id).then(
                    x => {
                        this.setState({ application: x.application, detailsMode: DetailsMode.View });

                        //, () => {
                        //    this.props.form.setFieldsValue(x.offering ?? {});
                        //});
                    },
                    x => NotificationService.error(x.message)
                )
            }
        });

    }
    getAccountDetails() {
        const urlState = this.props.match.params as { name: string } | undefined;
        const searchParams = new URLSearchParams(window.location.search);
        var successCheck = searchParams.get('a');
        var failureCheck = searchParams.get('b');

     

        if (urlState) {
            this.handler.GetApplicationById(urlState?.name).then(
                x => {
                    this.setState({ application: x, detailsMode: DetailsMode.View });
                    if (successCheck === "1") {
                        NotificationService.success("Payment was successful for Application " + x.applicationNumber, null, 0, false);
                    } else if (failureCheck === "2") {
                        NotificationService.error("Payment failed for Application " + x.applicationNumber, null, 0, false);
                    }

                    //, () => {
                    //    this.props.form.setFieldsValue(x.offering ?? {});
                    //});
                },
                x => NotificationService.error(x.message)
            );
        }

    }


    render() {
        var { getFieldDecorator } = this.props.form;
        return (
            <Row type="flex" justify="center">
                <Col>
                    <Row>
                        <Col span={24}>

                            <Row type="flex">

                                <Col style={{ paddingTop: "75px" }}>
                                    <Title>Application for {this.state.application?.offering?.title}</Title>

                                    <BorderlessDescriptions bordered column={1}>
                                        <Descriptions.Item label="JCSD Number">
                                            <div style={{ fontWeight: 'bolder' }}>
                                                {this.state.application?.account?.jcsdNumber}
                                            </div>
                                        </Descriptions.Item>

                                        <Descriptions.Item label="Application Number">
                                            <div style={{ fontWeight: 'bolder' }}>
                                                {this.state.application?.applicationNumber}
                                            </div>
                                        </Descriptions.Item>


                                        <Descriptions.Item label="Date Submitted">
                                            <div style={{ fontWeight: 'bolder' }}>
                                                {moment(this.state.application?.dateSubmitted).isValid() ? moment(this.state.application?.dateSubmitted)?.format('MMMM D YYYY h:mm a') : ''}
                                            </div>
                                        </Descriptions.Item>

                                        <Descriptions.Item label="Status">
                                            <div style={{ fontWeight: 'bolder' }}>
                                                {startCase(this.state.application?.status)}
                                            </div>
                                        </Descriptions.Item>
                                        <Descriptions.Item label={this.state.application?.offering?.sharePoolCategoryName ?? "Share Pool"}>
                                            <div style={{ fontWeight: 'bolder' }}>
                                                {this.state.application?.sharePool?.name}
                                            </div>
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Unit Price">
                                            <div style={{ fontWeight: 'bolder' }}>
                                                <NumberFormat value={this.state.application?.sharePool?.price} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={(this.state.application?.offering?.currency ?? '') + ' $'} />
                                            </div>
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Shares Requested">
                                            <div style={{ fontWeight: 'bolder' }}>
                                                <NumberFormat value={this.state.application?.sharesRequested} displayType={'text'} thousandSeparator={true} decimalScale={0} fixedDecimalScale={true} />
                                            </div>
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Sub Total">
                                            <div style={{ fontWeight: 'bolder' }}>
                                                <NumberFormat value={((this.state.application?.sharesRequested ?? 0) * (this.state.application?.sharePool?.price ?? 0))} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={(this.state.application?.offering?.currency ?? '') + ' $'} />
                                            </div>
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Processing Fee">
                                            <div style={{ fontWeight: 'bolder' }}>
                                                <NumberFormat value={this.state.application?.offering?.processingFee} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={(this.state.application?.offering?.currency ?? '') + ' $'} />
                                            </div>
                                        </Descriptions.Item>
                                        {this.state.application?.paymentMethod === PaymentMethod.CardPayment ? 
                                            <Descriptions.Item label="Service Fee">
                                                <div style={{ fontWeight: 'bolder' }}>
                                                    <NumberFormat value={(this.state.application?.amountDue ?? 0) - (((this.state.application?.sharesRequested ?? 0) * (this.state.application?.sharePool?.price ?? 0)) + (this.state.application?.offering?.processingFee ?? 0))} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={(this.state.application?.offering?.currency ?? '') + ' $'} />
                                                </div>
                                            </Descriptions.Item>

                                            : null
                                        }
                                        <Descriptions.Item label="Amount Due">
                                            <div style={{ fontWeight: 'bolder' }}>
                                                <NumberFormat value={this.state.application?.amountDue} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={(this.state.application?.offering?.currency ?? '') + ' $'} />
                                            </div>
                                        </Descriptions.Item>
                                        {
                                            this.state.application?.rejectionReason && this.state.application?.status === ApplicationStatus.UpdateRequired ?
                                            <Descriptions.Item label="Update Required Comments">
                                                <div style={{ fontWeight: 'bolder' }}>
                                                    {this.state.application?.rejectionReason}
                                                </div>
                                            </Descriptions.Item> : ''
                                        }
                                    </BorderlessDescriptions>



                                </Col>
                            </Row>

                            <RightAlignedRow style={{marginTop: '10px'}}>
                                <Col xs={24} sm={12} style={{ textAlign: 'left' }}>
                                    <NavLink to={'/applications'}>Back</NavLink>
                                </Col>
                                {(this.state.application?.status === ApplicationStatus.Submitted ||
                                    this.state.application?.status === ApplicationStatus.Draft ||
                                    this.state.application?.status === ApplicationStatus.UpdateRequired ||
                                    this.state.application?.status === ApplicationStatus.AwaitingPayment) ?

                                    <Col xs={24} sm={12}>
                                        <Button style={{ marginRight: '30px' }} type="danger" onClick={e => this.cancelApplication(this.state.application?.applicationId)} ghost>
                                            <span>Cancel</span>
                                        </Button>

                                        {(this.state.application?.paymentMethod === PaymentMethod.CardPayment) ?
                                            < BrandedButton onClick={e => this.generalApplyClicked(this.state.application?.offeringId, null)}>
                                                <span>Edit</span>
                                            </BrandedButton>
                                        : null
                                        }
                                    </Col>
                                    : null
                                }
                            </RightAlignedRow>
                        </Col>
                    </Row>
                </Col>
            </Row>

        );
    }
}

const IpoApplicationDetailsFormWithRouter = Form.create<Props>({
    name: 'IpoApplicationDetails',
})(IpoApplicationDetailsFormWithoutFormAndRouter);

const IpoApplicationDetailsForm = withRouter(IpoApplicationDetailsFormWithRouter);

export default IpoApplicationDetailsForm;



